// Google Analytics 4 Integration
export const GA_MEASUREMENT_ID = 'G-RNF7K8JXZK';

// Initialize GA4
export const initGA = () => {
  if (typeof window !== 'undefined') {
    // Load gtag.js
    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    script.async = true;
    document.head.appendChild(script);

    // Initialize dataLayer
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', GA_MEASUREMENT_ID, {
      page_path: window.location.pathname,
    });
  }
};

// Track page views
export const trackPageView = (url) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: url,
    });
  }
};

// Track custom events
export const trackEvent = (eventName, eventParams = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
};

// Predefined event tracking functions
export const trackQuoteSubmission = (service, propertyType) => {
  trackEvent('quote_submission', {
    event_category: 'engagement',
    event_label: service,
    service: service,
    property_type: propertyType,
  });
};

export const trackQuoteFormStart = () => {
  trackEvent('quote_form_start', {
    event_category: 'engagement',
    event_label: 'form_interaction',
  });
};

export const trackServiceClick = (serviceName) => {
  trackEvent('service_click', {
    event_category: 'engagement',
    event_label: serviceName,
    service_name: serviceName,
  });
};

export const trackPhoneClick = () => {
  trackEvent('phone_click', {
    event_category: 'conversion',
    event_label: 'contact_method',
  });
};

export const trackEmailClick = () => {
  trackEvent('email_click', {
    event_category: 'conversion',
    event_label: 'contact_method',
  });
};

export const trackSocialMediaClick = (platform) => {
  trackEvent('social_media_click', {
    event_category: 'engagement',
    event_label: platform,
    platform: platform,
  });
};

export const trackCTAClick = (ctaLocation) => {
  trackEvent('cta_click', {
    event_category: 'conversion',
    event_label: ctaLocation,
    location: ctaLocation,
  });
};

export const trackReviewsRefresh = () => {
  trackEvent('reviews_refresh', {
    event_category: 'engagement',
    event_label: 'testimonials',
  });
};

export const trackFAQExpand = (question) => {
  trackEvent('faq_expand', {
    event_category: 'engagement',
    event_label: question,
    question: question,
  });
};

export const trackPopupView = () => {
  trackEvent('popup_view', {
    event_category: 'engagement',
    event_label: 'quote_popup',
  });
};

export const trackPopupClose = () => {
  trackEvent('popup_close', {
    event_category: 'engagement',
    event_label: 'quote_popup',
  });
};
